/* Campaign enhancements. No purchase targets, product state or shared motion mutated. */
(() => {
  if (window.__sauveCampaign) return;
  window.__sauveCampaign = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const controllers = new Map();
  function marquee(root) {
    const button = root.querySelector('[data-marquee-pause]');
    const abort = new AbortController();
    let paused = false;
    let visible = false;
    const update = () => {
      root.classList.toggle('is-running', visible && !paused && !reduced.matches && !document.hidden);
      button.hidden = reduced.matches;
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused ? 'Reanudar movimiento' : 'Pausar movimiento';
    };
    // Missing IntersectionObserver deliberately leaves a static composition.
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      visible = entries.some(entry => entry.isIntersecting); update();
    }) : null;
    observer?.observe(root);
    button.addEventListener('click', () => { paused = !paused; update(); }, { signal: abort.signal });
    reduced.addEventListener('change', update, { signal: abort.signal });
    document.addEventListener('visibilitychange', update, { signal: abort.signal });
    update();
    return () => { observer?.disconnect(); abort.abort(); root.classList.remove('is-running'); button.hidden = true; };
  }
  function editorial(root) {
    const g = window.gsap, st = window.ScrollTrigger;
    if (!g || !st) return () => {};
    g.registerPlugin(st);
    const mm = g.matchMedia();
    mm.add({ motion: '(prefers-reduced-motion: no-preference)', desktop: '(min-width: 1000px)' }, context => {
      if (!context.conditions.motion) return;
      const frames = root.querySelectorAll('[data-campaign-frame]');
      const line = root.querySelector('[data-campaign-line]');
      const desktop = context.conditions.desktop;
      // Own wrappers, never .su-edit-piece img (existing hover owns that transform).
      const timeline = g.timeline({ scrollTrigger: { trigger: root, start: 'top 85%', end: 'bottom 35%', scrub: .65, invalidateOnRefresh: true } });
      frames.forEach((frame, index) => {
        const offset = desktop ? [40, -28, 58][index] : [12, -10, 16][index];
        timeline.fromTo(frame, { y: offset }, { y: -offset, ease: 'none' }, 0);
      });
      if (line) timeline.fromTo(line, { scaleX: 0, transformOrigin: 'left center' }, { scaleX: 1, ease: 'none' }, 0);
      // No pin, wheel interception, opacity hiding, or link movement.
    }, root);
    return () => mm.revert();
  }
  function init(scope) {
    scope.querySelectorAll('[data-campaign-marquee], [data-campaign-editorial]').forEach(root => {
      if (controllers.has(root)) return;
      controllers.set(root, root.hasAttribute('data-campaign-marquee') ? marquee(root) : editorial(root));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((destroy, root) => { if (event.target.contains(root)) { destroy(); controllers.delete(root); } });
  });
})();
